module.exports = __webpack_public_path__ + "static/media/solutions.2d7bb93d.svg";